import {l} from "types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {FavorittRessurs} from "../ressurser/FavorittRessurs";
import {Kontekst} from "../Kontekst";

export class FavorittTjeneste {

    static regNavn = "FavorittTjeneste";

    static forInjisering() {
        return [Kontekst.regNavn, FavorittRessurs.regNavn, FavorittTjeneste]
    }

    constructor(private kontekst: Kontekst, private favorittRessurs: FavorittRessurs) {
    }

    //offentlige metoder

    endreFavorittmarkeringForSak(sak: l.AgendaelementModell) {
        return this.endreFavorittmarkering(sak, l.FavorittType.sak);
    }

    endreFavorittmarkeringForMøte(møte: l.MøteModell) {
        return this.endreFavorittmarkering(møte, l.FavorittType.moete);
    }

    /** merk at favoritter ligger på dokumentnivå, ikke på dokumentversjonnivå i javakoden */
    endreFavorittmarkeringForDokumentversjon(dokumentVersjon:l.DokumentVersjonModell) {
        //siden vi ikke har tilgang til DokumentModell lager vi en her,
        //og sørger for at oppdater favoritter-liste propagerer til angitt dokumentVersjon
        const dokument = {id:dokumentVersjon.dokumentId, favoritter: dokumentVersjon.favoritter};
        return this.endreFavorittmarkering(dokument, l.FavorittType.dokument)
            .then(entitetMedOppdartertFavoritter => {
                dokumentVersjon.favoritter = entitetMedOppdartertFavoritter.favoritter;
            });
    }

    endreFavorittmarkeringForOppgave(oppgave: l.OppgaveModell) {
        return this.endreFavorittmarkering(oppgave, l.FavorittType.oppgave);
    }

    endreFavorittmarkeringForBeslutning(beslutning: l.BeslutningModell) {
        return this.endreFavorittmarkering(beslutning, l.FavorittType.beslutning);
    }

    //hjelpemetoder

    endreFavorittmarkering(entitet:l.HarFavoritter & l.EntitetModell<any>, type:l.FavorittType) {
        let respons = this.erFavoritt(entitet) ?
            this.favorittRessurs.slettSomFavoritt(type, entitet.id) :
            this.favorittRessurs.markerSomFavoritt(type, entitet.id);
        return respons.$promise.then(favoritter => {
            //oppdater entittet.favoritter
            entitet.favoritter = favoritter;
            return entitet;
        });
    }

    erFavoritt(entitet: l.HarFavoritter) {
        if (this.kontekst.erIkkeAutentisert()) return false;
        if (!_.isArray(entitet?.favoritter)) return false;
        return entitet.favoritter.some(f => f.brukerId === this.kontekst.autentisertBrukersId());
    }

}

